import { Component, OnInit } from '@angular/core';
import { PronunciationService, Pronunciation } from 'app/modules/admin/services/pronunciation.service';
import { MatDialog } from '@angular/material/dialog';
import { PronunciationEditComponent } from '../pronunciation-edit/pronunciation-edit.component';

@Component({
  selector: 'app-pronunciation',
  templateUrl: './pronunciation.component.html',
  styleUrls: ['./pronunciation.component.css']
})
export class PronunciationComponent implements OnInit {

  public entities: Pronunciation[];
  public isLoading = false;
  public search: string; 
  public searchIsActive: boolean;

  public countTotal: number;  
  
  private localStorageKey_numberOfRecords = "grid_numberOfItemsToDisplay_pronunciation"; 

  private localStorageKey_activeStatus = "search_pronunciation_status";

  public numberOfRecords = 0;
  public pageNumber = 1;  

  constructor(
    public dialog: MatDialog,  
    public pronunciationSvc: PronunciationService
  ) { }
   

  ngOnInit(): void {

    this.searchIsActive = this.GetDefaultOption_SearchIsActive(); 
    this.numberOfRecords = Number(localStorage.getItem(this.localStorageKey_numberOfRecords));
    if (this.numberOfRecords === 0) {
      this.numberOfRecords = 15;
    }

    
    this.loadEntities();
  }

  private loadEntities() {
    this.isLoading = true;
    this.pronunciationSvc.loadEntites().then(
      (data: Pronunciation[]) => {
 
        this.entities = data;
        console.log(this.entities);   

        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        console.log("error", err);
      }
    );
  }

  public add() {
     
    var newEntity = new Pronunciation();

    var modal = this.dialog.open(PronunciationEditComponent)
    modal.componentInstance.loadEntity(newEntity); 

    modal.afterClosed().subscribe((reloadIndex: boolean) => { 
      console.log("modal closed", reloadIndex); 
      if (reloadIndex !== undefined) {
        this.loadEntities();
      }  
    });

  }

  public edit(obj: Pronunciation) {
    console.log(obj); 
    var modal = this.dialog.open(PronunciationEditComponent)
    modal.componentInstance.loadEntity(obj); 

    modal.afterClosed().subscribe((reloadIndex: boolean) => { 
      console.log("modal closed", reloadIndex); 
      if (reloadIndex !== undefined) {
        this.loadEntities();
      }  
    });
  }


  public delete(obj: Pronunciation) {

    console.log(obj); 
    
    if (confirm("Are you sure you want to delete this item?")) {
      this.pronunciationSvc.delete(obj).then(
        (s)=> {
          this.loadEntities();
        }
      ).catch(
        (err)=> {
          alert("Error while deleting item");
        }
      )
    }

  }


  public changeNumberOfRecords() {
    localStorage.setItem(this.localStorageKey_numberOfRecords, this.numberOfRecords.toString());
  }
   

  public changeActiveStatus() {
    localStorage.setItem(this.localStorageKey_activeStatus, this.searchIsActive + "");
  }
  
  private GetDefaultOption_SearchIsActive() : boolean {
    var proofed = localStorage.getItem(this.localStorageKey_activeStatus);
    if (proofed === "false") {
      return false
    } else if (proofed === "true") {
      return true;
    }
    return null;
  }
 
  
private renderPaginationItemStatus(p: any) {
  //console.log("renderPaginationItemStatus", p, this.numberOfRecords ,p.getCurrent());
 
  var currentPage = p.getCurrent();
  var numberOfRecordsInSet = p.getTotalItems();

  var startingRecord = ((currentPage - 1) * this.numberOfRecords) + 1;

  if (currentPage == 1) {
    startingRecord = 1;
  }
   
  var endingRecord = startingRecord + (this.numberOfRecords - 1);
  if (endingRecord > numberOfRecordsInSet) {
    endingRecord = numberOfRecordsInSet;
  };
 
  return startingRecord + " to " + endingRecord; 
}
}

